// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"69498e5c","231":"95050a8b","664":"0d7c0d3f","959":"db0f5b70"}[chunkId] + ".chunk.js";
};